<template>
  <div>
      <div class="button-area">
        <span>工单详情</span>
        <Button @click="closeModel()" class="button-right">返回</Button>
      </div>
      <div class="form-area">
        <Form
          :disabled="true"
          style="width: 100%"
          :model="ruleForm"
          :label-width="100"
          label-position="left"
          ref="form">
          <Row>
            <Col span="24">
              <FormItem label="工单编号" prop="busiNumber">
                <Input
                  v-model="ruleForm.busiNumber"
                  placeholder="">
                </Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="姓名" prop="name">
                <Input
                  v-model="ruleForm.name"
                  placeholder="">
                </Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="联系方式" prop="phone">
                <Input
                  v-model="ruleForm.phone"
                  placeholder="">
                </Input>
              </FormItem>
            </Col>
            <Row>
              <Col span="12">
                <FormItem label="身份证号码" prop="identity">
                  <Input
                    v-model="ruleForm.identity"
                    placeholder="">
                  </Input>
                </FormItem>
              </Col>
            </Row>
            <Col span="12">
              <FormItem label="诉求类型" prop="type">
                <Select
                  v-model="ruleForm.type"
                  placeholder="">
                  <Option
                    v-for="item in typeoptions"
                    :key="item.value"
                    :value="item.value">
                    {{item.value}}
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="事件时间" prop="eventTime">
                <Input
                  v-model="ruleForm.eventTime"
                  placeholder=""
                  icon="md-time">
                </Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="信息保密" prop="secrecy">
                <Select
                  v-model="ruleForm.secrecy"
                  placeholder="">
                  <Option
                    v-for="item in secrecyoptions"
                    :key="item.value"
                    :value="item.value">
                    {{item.label}}
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="24">
              <FormItem label="诉求标题" prop="title">
                <Input
                  v-model="ruleForm.title"
                  placeholder="">
                </Input>
              </FormItem>
            </Col>
            <Col span="24">
              <FormItem label="诉求地址" prop="address">
                <Input
                  v-model="ruleForm.address"
                  placeholder="">
                </Input>
              </FormItem>
            </Col>
            <Col span="24">
              <FormItem label="诉求目的" prop="intent">
                <Input
                  v-model="ruleForm.intent"
                  placeholder="">
                </Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="诉求情绪" prop="emotion">
                <Select
                  v-model="ruleForm.emotion"
                  placeholder="">
                  <Option
                    v-for="item in emotionoptions"
                    :key="item.value"
                    :value="item.value">
                    {{item.value}}
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="24">
              <FormItem label="诉求内容" prop="content">
                <Input
                  v-model="ruleForm.content"
                  type="textarea"
                  :autosize="{ minRows: 4 }"
                  placeholder="">
                </Input>
              </FormItem>
            </Col>
            <Col span="24">
              <FormItem label="图片上传" prop="fileUrl">
                <div v-if="ruleForm.fileUrl && ruleForm.fileUrl.length">
                  <img
                    :key="index"
                    v-for="(item, index) in ruleForm.fileUrl"
                    @click="handleShowPreview(item.split(',')[1])"
                    style="width: 94px;height: 56px;margin-right: 20px;cursor: pointer;"
                    :src="item.split(',')[1]"
                    alt="">
                </div>
              </FormItem>
            </Col>
            <Col span="24">
              <FormItem label="反馈结果" prop="feedback">
                <Input
                  v-model="ruleForm.feedback"
                  type="textarea"
                  :autosize="{ minRows: 4 }"
                  placeholder="">
                 </Input>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
      <Modal
        v-model="preview"
        :width="500"
        title="图片"
        footer-hide>
        <img style="width: 100%;" :src="urlList" alt="">
      </Modal>
  </div>
</template>

<script>
import util from '@/libs/util.js'

export default {
  name: 'tqt_yql_item',
  data() {
    return {
      id: null,
      typeoptions: [
        {value: '12350工单'},
        {value: '举报'},
        {value: '表扬'},
        {value: '建议'},
        {value: '求助'},
        {value: '咨询'},
        {value: '投诉'},
        {value: '好差评'}
      ],
      secrecyoptions: [
        {value: '0', label: '显示'},
        {value: '1', label: '保密'}
      ],
      emotionoptions: [
        {value: '开心'},
        {value: '激动'},
        {value: '生气'},
        {value: '难过'},
        {value: '疑惑'},
        {value: '平淡'},
        {value: '其他'}
      ],
      //表单参数
      ruleForm: {
        busiNumber: '',
        name: '',
        phone: '',
        identity: '',
        type: '',
        eventTime: '',
        secrecy: '',
        title: '',
        address: '',
        intent: '',
        emotion: '',
        content: '',
        fileUrl: [],
        feedback: '',
      },
      preview: false,
      urlList: ''
    }
  },
  created () {
    if (this.$route.query && this.$route.query.id) {
      this.openModel(this.$route.query.id)
    }
  },
  methods: {
    // 打开模态框
    openModel(id) {
      console.log('🤡 ❗ openModel ❗ id:', id)
      this.$set(this, 'ruleForm', this.$options.data.call(this).ruleForm)
      this.$refs.form && this.$refs.form.resetFields()
      if (id) {
        this.id = id
        this.initForm()
      }
    },
    // 返回
    closeModel() {
      this.$set(this, 'ruleForm', this.$options.data.call(this).ruleForm)
      this.$refs.form && this.$refs.form.resetFields()
      this.id = null
      this.$router.back()
    },
    // 初始化from
    initForm () {
      util.http
        .post('/api/tqt/petition/getByOrderId',
          {
            id: this.id
          }
        )
        .then((response) => {
          console.log('🤡 ❗ response:', response)
          if (response.data.result.fileUrl) {
            response.data.result.fileUrl = response.data.result.fileUrl.split(';')
          }
          this.ruleForm = Object.assign({}, this.ruleForm, response.data.result)
          console.log('🤡 ❗ this.ruleForm:', this.ruleForm)
        })
        .finally(() => {
        })
    },
    // 预览图片
    handleShowPreview (url) {
      this.preview = true
      this.urlList = url
    }
  }
};
</script>

<style lang="less" scoped>
.button-right {
  width: 200px;
}
.button-area {
  padding: 0 60px;
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  color: #333333;
}
.form-area {
  margin: 0 60px;
  margin-top: 20px;
  /deep/.ivu-form-item-label {
    text-align: right !important;
  }
}
</style>
